export default __webpack_public_path__ + "static/media/H_wdt_c_cap_2.aaa5d7c1.mp3";